import styled from 'styled-components';
import { goToPFGT, mobileQuery } from '../../../utils';
import { infoStore, ParticipationStatus } from '../../../store/infoStore';
import { MODAL_TYPE, modalStore } from '../../../store/modalStore';
import { Ticket } from './Ticket';
import {
  EventTabType,
  MAIN_EVENT_TAB_STATUS,
  MAIN_TAB_STATUS,
  SUB_TAB_STATUS,
} from '../../../types/type';
import { tabStore } from '../../../store/tabStore';

export const MainEvent = () => {
  const { mainInfo, sideInfo } = infoStore();
  const { showModal } = modalStore();
  const { setSubTab, getCurrentSubTab, setMainTab } = tabStore();

  // 현재 활성화된 서브탭
  const activeSubTab = getCurrentSubTab(MAIN_TAB_STATUS.MAIN_EVENT);

  // 이벤트 타입 확인 (메인/사이드)
  const isMainTab = activeSubTab === SUB_TAB_STATUS.MAIN_EVENT_MAIN;
  const eventTab = isMainTab ? EventTabType.MAIN : EventTabType.SIDE;
  const isMainEvent = eventTab === EventTabType.MAIN;

  // 탭 선택 핸들러
  const handleSelectTab = (tabId: SUB_TAB_STATUS) => {
    if (tabId === SUB_TAB_STATUS.MAIN_EVENT_MAIN) {
      // 메인 이벤트 티켓 확인
      if (mainInfo.status !== ParticipationStatus.CHECK_ELIGIBLE) {
        showModal({ modalType: MODAL_TYPE.CHECK_MAIN_TICKET });
        return;
      }
    } else {
      // 사이드 이벤트 티켓 확인
      if (sideInfo.status !== ParticipationStatus.CHECK_ELIGIBLE) {
        showModal({ modalType: MODAL_TYPE.CHECK_SIDE_TICKET });
        return;
      }
    }

    // 탭 변경
    setSubTab(MAIN_TAB_STATUS.MAIN_EVENT, tabId);
  };

  return (
    <>
      <TabContainer>
        <TabButton
          $type={SUB_TAB_STATUS.MAIN_EVENT_MAIN}
          $isActive={isMainTab}
          onClick={() => handleSelectTab(MAIN_EVENT_TAB_STATUS.MAIN)}
        >
          <TabText $isActive={isMainTab}>메인 이벤트</TabText>
        </TabButton>

        <TabButton
          $type={SUB_TAB_STATUS.MAIN_EVENT_SIDE}
          $isActive={!isMainTab}
          onClick={() => handleSelectTab(MAIN_EVENT_TAB_STATUS.SIDE)}
        >
          <TabText $isActive={!isMainTab}>사이드 이벤트</TabText>
        </TabButton>
      </TabContainer>

      <WelcomeTextContainer>
        <WelcomeText $isMainEvent={isMainEvent}>
          {isMainEvent ? '메인' : '사이드'} 이벤트 참가 티켓 획득을 축하합니다!
        </WelcomeText>
      </WelcomeTextContainer>
      <BottomInfoContainer>
        <Ticket isMainEvent={isMainEvent} />
        <TicketDetailContainer>
          <TicketDetailText>
            PFGT 바로 가기 버튼을 클릭 후 선수 등록을 진행해주세요.
          </TicketDetailText>
          <TicketDetailText>토너먼트 참가 안내에서 상세 일정을 확인해주세요.</TicketDetailText>
          <TicketDetailText>
            {isMainEvent ? '메인' : '사이드'} 이벤트 참가 시 직원분께 QR 코드를 보여주세요.
          </TicketDetailText>
        </TicketDetailContainer>
      </BottomInfoContainer>

      <BottomTabContainer>
        <GoOfflineEventDetailBtn
          onClick={() => {
            setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
            setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_OFFLINE);
          }}
        >
          오프라인 이벤트
          <br />
          참가안내
        </GoOfflineEventDetailBtn>
        <GoPFGTBtn onClick={goToPFGT}>PFGT 바로가기</GoPFGTBtn>
      </BottomTabContainer>
    </>
  );
};

// 스타일 컴포넌트
const WelcomeText = styled.h4<{ $isMainEvent: boolean }>`
  font-weight: 400;
  font-size: 36px;
  line-height: 46px;
  letter-spacing: -0.06em;
  color: ${({ $isMainEvent }) => ($isMainEvent ? '#FF408C' : '#329CFF')};
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  ${mobileQuery} {
    font-size: 18px;
    line-height: 25px;
  }
`;

const WelcomeTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
`;

const BottomInfoContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 180px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 720px) {
    padding-bottom: 130px;
  }

  ${mobileQuery} {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const GoPFGTBtn = styled.button`
  height: 100%;
  left: 50%;
  width: 50%;
  height: 70px;
  background-color: #721b80;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: #ffffff;
`;

const GoOfflineEventDetailBtn = styled.button`
  height: 100%;
  left: 0%;
  width: 50%;
  height: 70px;
  background-color: #10418b;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.04em;
  color: #ffffff;
`;

const TicketDetailContainer = styled.ul`
  padding-left: 10px;
  margin: 0;
  margin-top: 10px;
  list-style: none;

  ${mobileQuery} {
    padding-left: 5px;
  }
`;

const TicketDetailText = styled.li`
  font-weight: 500;
  font-size: 26px;
  line-height: 36px;
  letter-spacing: -1px;
  color: #939393;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    width: 4px;
    height: 4px;
    background: #939393;
    border-radius: 50%;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
  }
  ${mobileQuery} {
    font-size: 14px;
    line-height: 20px;
  }
`;

const TabContainer = styled.div`
  display: flex;
  max-width: 600px;
  margin: 0 auto;
  padding-top: 40px;

  ${mobileQuery} {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
  }
`;

const TabButton = styled.div<{ $isActive: boolean; $type: string }>`
  display: flex;
  flex: 1;
  height: 42px;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  background: ${(props) =>
    props.$isActive
      ? props.$isActive && props.$type === 'main'
        ? 'linear-gradient(95deg, #b3004e 20.33%, #87083f 93.59%)'
        : 'linear-gradient(102deg, #0059ff -6.05%, #1140a7 58.73%)'
      : '#434343'};
  border: 2px solid
    ${(props) =>
      props.$isActive
        ? props.$isActive && props.$type === 'main'
          ? '#c30b5f'
          : '#1859c7'
        : '#434343'};

  &:first-child {
    margin-right: 6px;
  }

  ${mobileQuery} {
    height: 30px;
  }
`;

const TabText = styled.h3<{ $isActive: boolean }>`
  font-weight: ${(props) => (props.$isActive ? '600' : '500')};
  font-size: 20px;
  line-height: 34px;
  color: ${(props) => (props.$isActive ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.5)')};

  ${mobileQuery} {
    font-size: 14px;
    line-height: 17px;
  }
`;
